import { isNumber, ISoilAnalysis } from "../../omnia";

export function validateSoil(sa: ISoilAnalysis) {

    if (!sa) return null

    const errors = newErrorSet<"OrganicMatter" | "Sand" | "Silt" | "Clay">()

    if (isNumber(sa.OrganicMatter) && (sa.OrganicMatter < 0.001 || sa.OrganicMatter > 1)) {
        errors.OrganicMatter = true;
    }

    if (isNumber(sa.Sand) && (sa.Sand < 0.001 || sa.Sand > 1)) {
        errors.Sand = true;
    }

    if (isNumber(sa.Silt) && (sa.Silt < 0.001 || sa.Silt > 1)) {
        errors.Silt = true;
    }

    if (isNumber(sa.Clay) && (sa.Clay < 0.001 || sa.Clay > 1)) {
        errors.Clay = true;
    }

    if (Object.keys(errors).length === 0) {
        return null
    }

    return errors
}


export function validateSoilProp(sa: ISoilAnalysis) {

    if (!sa) return null

    const errors = newErrorSet<"SoilHealthIndex" | "CO2BurstIndex">()

    if (isNumber(sa.SoilHealthIndex) && (sa.SoilHealthIndex < 0 || sa.SoilHealthIndex > 6)) {
        errors.SoilHealthIndex = true
    }

    if (isNumber(sa.CO2BurstIndex) && (sa.CO2BurstIndex < 0 || sa.CO2BurstIndex > 6)) {
        errors.CO2BurstIndex = true
    }

    if (Object.keys(errors).length === 0) {
        return null
    }

    return errors

}


export function validateNutrients(sa: ISoilAnalysis) {

    if (!sa) return null

    const errors = newErrorSet<"P2O5" | "K2O" | "MgO" | "PhWater">()

    if (sa.P2O5 < 0) {
        errors.P2O5 = true
    }

    if ((sa.K2O < 10 || sa.K2O > 3000)) {
        errors.K2O = true
    }

    if ((sa.MgO < 10 || sa.MgO > 1250)) {
        errors.MgO = true
    }

    if ((sa.WaterpH < 4 || sa.WaterpH > 9)) {
        errors.PhWater = true
    }

    if (Object.keys(errors).length == 0) {
        return null
    }

    return errors
}

function newErrorSet<T extends string>() {
    return {} as { [k in T]?: boolean }
}
